import {
    MANAGER_ACTIVE_OFFERS_LOADED,
    MANAGER_ALL_OFFERS_LOADED,
    MANAGER_ALL_OFFERS_LOADING,
    MANAGER_DEPRECATED_OFFERS_LOADED,
    MANAGER_INACTIVE_OFFERS_LOADED,
    MANAGER_OFFER_CHILDREN_LOADED,
    MANAGER_OFFER_DELETED,
    MANAGER_OFFER_DEPRECATED,
    MANAGER_OFFER_SAVED,
    MANAGER_OFFER_SAVING,
    MANAGER_OFFERS_LOADING,
    OFFER_CARD_DATA_LOADED,
    MANAGER_OFFER_CHANGE_VIEW, MANAGER_GROUPED_PROMOTION_LINKS_LOADING, MANAGER_GROUPED_PROMOTION_LINKS_LOADED,
    MANAGER_GROUPED_PROMOTION_LINKS_CLEAR,
} from "../../actions/actionTypes";


const initialState = {
    allOffers: [],
    activeOffers: [],
    inactiveOffers: [],
    deprecatedOffers: [],
    offerCardData: null,
    loading: false,
    allOfferLoading: false,
    children: null,
    isLine: false,
    groupedPromotionLinksLoading: false,
    groupedPromotionLinks: [],
};


export default function (state = initialState, action = {}) {
    switch (action.type) {
        case MANAGER_OFFERS_LOADING:
            return {
                ...state,
                loading: true
            };
        case MANAGER_ACTIVE_OFFERS_LOADED:
            return {
                ...state,
                activeOffers: action.payload,
                loading: false
            };
        case MANAGER_INACTIVE_OFFERS_LOADED:
            return {
                ...state,
                inactiveOffers: action.payload,
                loading: false
            };
        case MANAGER_DEPRECATED_OFFERS_LOADED:
            return {
                ...state,
                deprecatedOffers: action.payload,
                loading: false
            };
        case MANAGER_ALL_OFFERS_LOADING:
            return {
                ...state,
                allOfferLoading: true
            };
        case MANAGER_ALL_OFFERS_LOADED:
            return {
                ...state,
                allOfferLoading: false,
                allOffers: action.payload,
            };
        case OFFER_CARD_DATA_LOADED:
            return {
                ...state,
                offerCardData:action.payload,
                loading: false
            };
        case MANAGER_OFFER_SAVING:
            return {
                ...state,
                saving: true
            };
        case MANAGER_OFFER_DEPRECATED:
        case MANAGER_OFFER_DELETED:
        case MANAGER_OFFER_SAVED:
            return {
                ...state,
                offerCardData: action.payload,
                loading: false,
                saving: false,
            };
        case MANAGER_OFFER_CHILDREN_LOADED:
            return {
                ...state,
                children: action.payload
            };
        case MANAGER_OFFER_CHANGE_VIEW:
            return {
                ...state,
                isLine: !state.isLine  // инвертируем текущее значение isLine
            };
        case MANAGER_GROUPED_PROMOTION_LINKS_LOADING:
            return {
                ...state,
                groupedPromotionLinksLoading: true
            };
        case MANAGER_GROUPED_PROMOTION_LINKS_LOADED:
            return {
                ...state,
                groupedPromotionLinksLoading: false,
                groupedPromotionLinks: action.payload,
            };
        case MANAGER_GROUPED_PROMOTION_LINKS_CLEAR:
            return {
                ...state,
                groupedPromotionLinksLoading: false,
                groupedPromotionLinks: [],
            };
        default:
            return state;

    }
}
